const mEditionMapEnrollmentsFamiliesModalCreate = {
  mEditionMapEnrollmentsFamiliesModalCreate: {
    alerts: {
      createFamilia: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El equipo fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Nombre de equipo',
        placeholder: ''
      }
    },

    title: 'Crear Equipo',

    validation: {
      nombre: {
        maxLength: 'La longitud máxima permitida es de 60 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracteres.',
        required: 'Nombre de equipo es requerido.'
      }
    }
  }
}

export default mEditionMapEnrollmentsFamiliesModalCreate
